module.exports = __webpack_public_path__ + "static/media/hand-point-up.dd45be4e.svg";